import { cn } from "../../../helpers/utils";
import CloseButton from "../../atoms/buttons/CloseButton";
import { useNavigate } from "react-router-dom";
import SubHeader from "../../molecules/layouts/app/SubHeader";

const AppContent = ({
  children,
  title = "",
  isConfirmedPage = false,
  contentOverBanner = false,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        "relative bg-white rounded-lg m-4 p-4 md:bg-transparent md:rounded-none md:m-0 md:p-0",
        contentOverBanner && !isConfirmedPage && "-mt-14",
        isConfirmedPage &&
          !contentOverBanner &&
          "flex-1 w-full bg-white m-0 rounded-none p-4 md:bg-transparent"
      )}
    >
      {isConfirmedPage && (
        <div className="absolute top-2 right-2">
          <CloseButton onClick={() => navigate("/")} />
        </div>
      )}
      <div className="flex justify-center md:block">
        <div className="w-full max-w-md md:max-w-full md:w-auto">
          {title && <SubHeader title={title} />}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AppContent;
